export const transformPriceListBestSellers = (list: any) =>
  list.map(item => ({
    inStock: item.in_stock,
    mrp: item.mrp,
    productName: item.product_name,
    productUrl: item.product_url,
    quantity: item.quantity,
  }));

export const transformPriceList = (data: any) => {
  if (!data) {
    return {};
  }
  return {
    bestSellers: transformPriceListBestSellers(data.best_sellers || []),
    title: data.title,
    lastUpdated: data.last_updated,
  };
};

export const transformAboutUs = (data: any) => {
  if (!data) {
    return {};
  }
  return {
    brandInfo: data.brand_info,
  };
};
